<script setup lang="ts">
	import { MzTitle } from '@monizze/monizze-components';
	import { useI18n } from 'vue-i18n';

	const { t } = useI18n();
</script>

<template>
	<div class="flex flex-col gap-6 items-center">
		<mz-title type="h1" class="text-center" :text="t('maintenance.page.title')" />
		<p class="text-center">{{ t('maintenance.page.description') }}</p>
		<img class="size-[304px]" src="/Maintenance/maintenance.svg" :alt="t('maintenance.page.title')" />
	</div>
</template>
